import { FronteggContext } from '@frontegg/rest-api';
import moment from 'moment';
import { Axios } from 'src/lib';
import {
  getAllAppointmentConfig,
  getAppointmentsByStatusConfig,
} from 'src/lib/requests';
import {
  addRecentSearchConfig,
  appointmentTypeConfig,
  checkPatientDetailsConfig,
  convertAppointmentToAuraEncounterConfig,
  createAppointmentConfig,
  downloadCSVConfig,
  editAppointmentConfig,
  flagNameOrgConfig,
  getAllPractitionersNamesConfig,
  getAppointmentByFiltersConfig,
  getAppointmentByUuidConfig,
  getAppointmentCountDateConfig,
  getAppointmentDetailsbyUuidConfig,
  getAppointmentReminderConfig,
  getAppointmentsSummaryConfig,
  getConditionByAppointmentTypeConfig,
  getConditionsConfig,
  getDoctorAppointmentStatusConfig,
  getIntakeSummaryFeedbackConfig,
  getOrganizationSettingsMappingConfig,
  getPatientDetailsByOrgConfig,
  getPatientNamesConfig,
  getPractionerDetailsByOrgConfig,
  getRecentSearchConfig,
  getRegenerateIntakeConfig,
  notificationHistoryConfig,
  patientAutoCompleteConfig,
  patientNamesOrgConfig,
  practitionerNamesOrgConfig,
  practitionerPreferencesConfig,
  removeAppointmentConfig,
  settingsOrgFlagConfig,
  uploadCSVConfig,
} from 'src/lib/requests/appointment.url';
import { storeInLocal } from 'src/lib/storage';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import store from '..';
import { getAllAppointmentSlice, getErrorCode } from '../slices';
import {
  appointmentLoading,
  appointmentTypesSlice,
  apptsAPICallSlice,
  apptsTotalSlice,
  bulkAppointmentHistoryLoadingSlice,
  bulkAppointmentHistorySlice,
  csvColumnMappingsLoadingSlice,
  csvDownloadUrlSlice,
  existingPatientDetailsSlice,
  filteredApptsTotalSlice,
  flagNameOrgSlice,
  getAllPractitionersNamesSlice,
  getAppointmentByFilterSlice,
  getAppointmentCountDateSlice,
  getAppointmentDetailsByUuidSlice,
  getAppointmentStatusMappingsLoadingSlice,
  getAppointmentStatusMappingsSlice,
  getAppointmentUuidSlice,
  getAppointmentsByStatusSlice,
  getAppointmentsSummarySlice,
  getCSVColumnMappingsSlice,
  getCSVTimezoneLoadingSlice,
  getCSVTimezoneSlice,
  getConditionByAppointmentTypeSlice,
  getConditionByPractitionerLoadingSlice,
  getConditionMappingsLoadingSlice,
  getConditionMappingsSlice,
  getConditionSlice,
  getDoctorAppointmentStatusSlice,
  getLookbackPeriodsLoadingSlice,
  getLookbackPeriodsSlice,
  getNewIntakeSummary,
  getNotificationHistorySlice,
  getPatientNamesListSlice,
  getPractitionerPreferencesSlice,
  getPractitionersAndPatientsSlice,
  getProviderMappingsSlice,
  getRecentSearchSlice,
  isApptDeleted,
  isUUIDover,
  patientAutoCompleteSlice,
  patientNamesOrgSlice,
  practitionerNamesOrgbyIdSlice,
  providerMappingsLoadingSlice,
  remainderPatientApptsSlice,
  scheduleLoading,
  selfAPILoadingSlice,
  settingsOrgFlagSlice,
  showPractitionerEmailTagSlice,
  getCSVDateTimeFormatsSlice,
} from '../slices/appointments.slice';
import {
  assessmentRevAiResponseSlice,
  diagnosticImagingSlice,
  diagnosticsRevAiResponseSlice,
  physicalExamRevAiResponseSlice,
  physicalExaminationSlice,
  planSlice,
  revaiResponse,
} from '../slices/careConnect.slice';
import { getSettingsNotificationsSlice } from '../slices/settings.slice';
import {
  getAppointmentAllEndDateFilter,
  getAppointmentAllStartDateFilter,
} from '../../modules/appointments/utils/helpers';
import { analytics } from 'src/services';

export const getAllAppointment = () => {
  return async (dispatch) => {
    try {
      const { url } = getAllAppointmentConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response?.appointments) {
        dispatch(getAllAppointmentSlice(response?.appointments));
      }
    } catch (e) {
      getErrorCode(500);
    }
  };
};

export const getAppointmentsByStatus = (
  itemsPerPage,
  fetchCounter,
  sortBy = 'start_date',
  sortDirection = 'desc'
) => {
  return async (dispatch) => {
    dispatch(filteredApptsTotalSlice(null));
    fetchCounter === 0 ? dispatch(apptsAPICallSlice(true)) : '';
    fetchCounter === undefined ? dispatch(appointmentLoading(true)) : '';
    let { currentPractitioner } = store.getState().practitionerState;
    try {
      const tz = moment.tz.guess();
      const { url } = getAppointmentsByStatusConfig(
        itemsPerPage,
        tz,
        sortBy,
        sortDirection
      );
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      dispatch(appointmentLoading(false));
      const response = result?.data?.appointments;
      if (result?.status === 200 && response) {
        await dispatch(getAppointmentsByStatusSlice(response));
        dispatch(apptsTotalSlice(result?.data?.total));
        dispatch(getAppointmentUuidSlice({}));
        dispatch(getNewIntakeSummary({ intakeSummary: null, id: null }));
        dispatch(revaiResponse(null));
        dispatch(physicalExamRevAiResponseSlice(null));
        dispatch(diagnosticsRevAiResponseSlice(null));
        dispatch(assessmentRevAiResponseSlice(null));
        dispatch(physicalExaminationSlice(null));
        dispatch(diagnosticImagingSlice(null));
        dispatch(planSlice(null));
        if (localStorage.getItem('appointment_view') !== 'CALENDAR') {
          storeInLocal(
            `${currentPractitioner?.org_uuid}_filter_practitioner_id`,
            ''
          );
          storeInLocal(
            `${currentPractitioner?.org_uuid}_filter_patient_name`,
            ''
          );
        }
        storeInLocal(`${currentPractitioner?.org_uuid}_filter_startDate`, '');
        storeInLocal(`${currentPractitioner?.org_uuid}_filter_endDate`, '');
        storeInLocal(`${currentPractitioner?.org_uuid}_filter_birthDate`, '');
        storeInLocal(`${currentPractitioner?.org_uuid}_filter_status`, '');
        storeInLocal(
          `${currentPractitioner?.org_uuid}_isPatientSelected`,
          false
        );

        dispatch(apptsAPICallSlice(false));
      }
    } catch (e) {
      dispatch(appointmentLoading(false));
      getErrorCode(500);
    }
  };
};

// Get Appointment by UUID
export const getAppointmentByUuid = (uuid, user) => {
  return async (dispatch) => {
    dispatch(scheduleLoading(true));
    try {
      const { url } = getAppointmentByUuidConfig();
      const token = FronteggContext.getAccessToken();
      let { currentPractitioner } = store.getState().practitionerState;
      const body = {
        appt_uuid: encodeURI(uuid),
      };
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const result = await Axios.post(url, body, { headers });
      const response = result?.data;
      if (result?.status === 200 && response?.appointment_details) {
        analytics.track('Viewed CareConnect Summary', {
          appointment_date: response?.appointment_details?.start_date,
          appointment_id: response?.appointment_details?.appointment_id,
          appointment_status:
            response?.appointment_details?.chat_completion_status,
          is_careconnect_summary_generated: 'True',
          email: user?.email,
          practitioner_name: `${response?.appointment_details?.practitioner_firstName} ${response?.appointment_details?.practitioner_last_name}`,
        });
        dispatch(getAppointmentUuidSlice(response));
        storeInLocal(
          `${currentPractitioner?.org_uuid}_practitioner_id`,
          response?.appointment_details?.practitioner_id
        );
        storeInLocal(
          `${currentPractitioner?.org_uuid}_condition_id`,
          response?.appointment_details?.condition_id
        );
        dispatch(scheduleLoading(false));
        dispatch(isUUIDover(true));
      }
      if (result?.status === 200 && response?.message) {
        dispatch(getAppointmentUuidSlice(response));
        dispatch(isApptDeleted(true));
        dispatch(isUUIDover(true));
      }
    } catch (e) {
      dispatch(scheduleLoading(false));
      getErrorCode(500);
    }
  };
};

// Appointment Table Filter values API
export const getAppointmentByFilter = (
  practitioner_ids = [],
  patient_name = '',
  startDate = '',
  endDate = '',
  status = '',
  type,
  itemsPerPage,
  patientId = '',
  sortBy = 'start_date',
  sortDirection = 'desc'
) => {
  return async (dispatch) => {
    type === 'normal' ? dispatch(appointmentLoading(true)) : null;
    try {
      const tz = moment.tz.guess();
      const { url } = getAppointmentByFiltersConfig(
        itemsPerPage,
        tz,
        sortBy,
        sortDirection
      );

      let patientIntakeStatus = '';
      let patientInVisitStatus = '';
      if (status) {
        const [splitType, value] = status.split('-');
        if (splitType === 'intake') {
          patientIntakeStatus = value;
        } else if (splitType === 'invisit') {
          patientInVisitStatus = value;
        }
      }

      const data = {
        practitioner_ids: practitioner_ids || [],
        patient_name: patient_name || '',
        start_date: startDate !== 'All Time' ? startDate : '',
        end_date: endDate !== 'All Time' ? endDate : '',
        chat_completion_status: patientIntakeStatus || '',
        in_visit_status: patientInVisitStatus || '',
        patient_id: patientId || '',
      };

      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data?.Appointments;
      const remainderPatientAppts = result?.data?.reminder_patient_appt_count;
      if (result?.status === 200) {
        dispatch(remainderPatientApptsSlice(remainderPatientAppts));
        dispatch(getAppointmentByFilterSlice(response));
        dispatch(filteredApptsTotalSlice(result?.data?.total));
      }
      dispatch(appointmentLoading(false));
    } catch (e) {
      getErrorCode(500);
      dispatch(appointmentLoading(false));
    }
  };
};

// Create Appointment
export const createAppointment = (
  data,
  setIsOpen,
  setConditionByType,
  setUpdatedEmailsArray,
  setRadioButtonvalue,
  startIndex,
  setSendNow,
  setCheckDOB,
  setCheckPhone,
  isfilterOn,
  filterValue,
  setSubmitLoading
) => {
  return async (dispatch) => {
    try {
      const { url } = createAppointmentConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data;
      const today = moment().format('YYYY-MM-DD');

      if (result?.status === 201 && response) {
        setSendNow(false);
        setIsOpen(false);
        setConditionByType([]);
        showToastSuccess('Patient appointment created');
        dispatch(getConditionByAppointmentTypeSlice({}));
        dispatch(patientAutoCompleteSlice({}));
        dispatch(getPractitionerPreferencesSlice([]));
        dispatch(getSettingsNotificationsSlice(null));
        setUpdatedEmailsArray([]);
        setRadioButtonvalue(1);
        dispatch(showPractitionerEmailTagSlice(false));
        setCheckDOB('');
        setCheckPhone('');
        setSubmitLoading(false);
        const practitionerIds =
          filterValue?.doctorName?.length > 0 ? filterValue?.doctorName : [];
        const patientName = filterValue?.patientName || [];
        const patientId = filterValue?.patientId || '';
        const startDate = filterValue?.startDate || today;
        const endDate = filterValue?.endDate || today;

        try {
          if (filterValue.datefilter === 'All time') {
            if (
              filterValue?.doctorName?.length === 0 &&
              filterValue?.patientName === '' &&
              filterValue?.status === ''
            ) {
              dispatch(
                getAppointmentsByStatus(
                  startIndex,
                  undefined,
                  'start_date',
                  'desc'
                )
              );
            } else {
              dispatch(
                getAppointmentByFilter(
                  practitionerIds,
                  patientName,
                  getAppointmentAllStartDateFilter(''),
                  getAppointmentAllEndDateFilter(''),
                  filterValue ? filterValue.status : '',
                  'normal',
                  startIndex,
                  patientId,
                  'start_date',
                  'desc'
                )
              );
            }
          } else {
            dispatch(
              getAppointmentByFilter(
                practitionerIds,
                patientName,
                getAppointmentAllStartDateFilter(startDate),
                getAppointmentAllEndDateFilter(endDate),
                filterValue ? filterValue.status : '',
                'normal',
                startIndex,
                patientId,
                'start_date',
                'desc'
              )
            );
          }
          dispatch(getAppointmentPractitionerAndPatients());
        } catch (error) {
          // ignore any errors from list refresh calls to avoid misrepresenting as create appointment error
        }
      }
    } catch (e) {
      getErrorCode(500);
      showToastError('Error creating appointment');
      dispatch(appointmentLoading(false));
      setSubmitLoading(false);
    }
  };
};

//  Get Doctor Appointments Status
export const getDoctorAppointmentStatus = () => {
  return async (dispatch) => {
    try {
      const { url } = getDoctorAppointmentStatusConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.appointmentStatus;
      if (result?.status === 200 && response) {
        dispatch(getDoctorAppointmentStatusSlice(response));
      }
    } catch (e) {
      getErrorCode(500);
    }
  };
};

// Get All Practitioners Names
export const getAllPractitionersNames = (body) => {
  return async (dispatch) => {
    try {
      const { url } = getAllPractitionersNamesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data?.practitioners;
      if (result?.status === 200 && response) {
        dispatch(getAllPractitionersNamesSlice(response));
      }
    } catch (e) {
      getErrorCode(500);
    }
  };
};

// Get Appointments summary for current organisation
export const getAppointmentsSummaryData = () => {
  return async (dispatch) => {
    try {
      const { url } = getAppointmentsSummaryConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAppointmentsSummarySlice(response));
      }
    } catch (e) {
      getErrorCode(500);
    }
  };
};

// Get All conditions by Practitioner in Add New Appointment page
export const getConditions = (data) => {
  return async (dispatch) => {
    try {
      const { url } = getConditionsConfig();
      const token = FronteggContext.getAccessToken();
      const body = {
        practitioner_id: data,
      };
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data?.Conditions;
      if (result?.status === 200 && response) {
        dispatch(getConditionSlice(response));
      }
    } catch (e) {
      getErrorCode(500);
    }
  };
};

// Get Appointment Count date wise for any month
export const getAppointmentCountDate = (year, month) => {
  return async (dispatch) => {
    dispatch(appointmentLoading(true));
    try {
      const { url } = getAppointmentCountDateConfig(year, month);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAppointmentCountDateSlice(response));
      }
    } catch (e) {
      getErrorCode(500);
      dispatch(appointmentLoading(false));
    }
  };
};

// Regenerate Intake Summary API
export const regenerateIntakeSummary = (id) => {
  return async (dispatch) => {
    dispatch(appointmentLoading(true));
    try {
      const { url } = getRegenerateIntakeConfig();
      const data = {
        appointment_id: id,
      };
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data?.New_Intake_Summary;
      if (result?.status === 200 && response) {
        dispatch(getNewIntakeSummary({ intakeSummary: response, id }));
      }
    } catch (e) {
      getErrorCode(500);
      dispatch(appointmentLoading(false));
    }
  };
};

// Update Feedback form
export const updateIntakeSummaryFeedback = (
  data,
  setIsOpen,
  setSubmitLoading
) => {
  return async (dispatch) => {
    dispatch(appointmentLoading(true));
    try {
      const { url } = getIntakeSummaryFeedbackConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, data, { headers });
      if (result?.status === 200) {
        showToastSuccess('Feedback submitted');
        setIsOpen(false);
        setSubmitLoading(false);
      }
    } catch (e) {
      getErrorCode(500);
      showToastError(e);
    }
  };
};

// Appointment Reminders
export const sendAppointmentReminders = (appt_uuid, cachedUserEmail) => {
  return async () => {
    try {
      let { url } = getAppointmentReminderConfig();
      url += `/${appt_uuid}`;

      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const body = {
        sent_by: cachedUserEmail,
      };

      const result = await Axios.post(url, body, { headers });
      if (result?.status === 200) {
        showToastSuccess('Reminder sent to patient');
      }
    } catch (e) {
      showToastError('Could not send reminders', e);
    }
  };
};

// Remove Appointment by Id
export const removeAppointmentAction = (
  appt_uuid,
  setIsOpen,
  startIndex,
  isfilterOn,
  setSubmitLoading,
  filterValue
) => {
  return async (dispatch) => {
    try {
      const { url } = removeAppointmentConfig(appt_uuid);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Appointment removed successfully');
        if (isfilterOn) {
          dispatch(
            getAppointmentByFilter(
              filterValue?.doctorName,
              filterValue?.patientName,
              getAppointmentAllStartDateFilter(filterValue?.startDate),
              getAppointmentAllEndDateFilter(filterValue?.endDate),
              filterValue?.status,
              'reload',
              startIndex,
              filterValue?.patientId || '',
              'start_date',
              'desc'
            )
          );
        } else {
          dispatch(
            getAppointmentsByStatus(startIndex, undefined, 'start_date', 'desc')
          );
        }
        dispatch(getAppointmentPractitionerAndPatients());
        setIsOpen(false);
        setSubmitLoading(false);
      }
    } catch (e) {
      showToastError('Failed to remove appointment');
    }
  };
};

export const markAppointmentOptOut = (appt_uuid, isOptOut, callback) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.put(
        `/opt_out_appointment/${appt_uuid}`,
        { is_opt_out: isOptOut },
        { headers }
      );
      if (result?.status === 200) {
        showToastSuccess(
          `Patient notifications ${isOptOut ? 'muted' : 'unmuted'} successfully`
        );
        callback?.();
      }
    } catch (e) {
      showToastError(
        `Failed to ${isOptOut ? 'mute' : 'unmute'} patient notifications`
      );
    }
  };
};

export const appointmentTypesAction = () => {
  return async (dispatch) => {
    try {
      const { url } = appointmentTypeConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(appointmentTypesSlice(response?.appointment_types));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const getConditionByAppointmentType = (
  practitionerId,
  radioButtonValue,
  type
) => {
  return async (dispatch) => {
    dispatch(getConditionByPractitionerLoadingSlice(true));
    try {
      const { url } = getConditionByAppointmentTypeConfig();
      const token = FronteggContext.getAccessToken();
      const body = {
        practitioner_id: practitionerId,
        appointment_type_id: radioButtonValue,
        appt_creation: type,
      };
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(getConditionByAppointmentTypeSlice(response));
        dispatch(showPractitionerEmailTagSlice(true));
        dispatch(getConditionByPractitionerLoadingSlice(false));
      }
    } catch (e) {
      dispatch(getConditionByPractitionerLoadingSlice(false));
    }
  };
};

export const patientAutoCompleteAction = (
  patientId,
  setFieldValue,
  setShowExistingFlag
) => {
  return async (dispatch) => {
    try {
      const { url } = patientAutoCompleteConfig(patientId);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const digits = response?.birth_date.replace(/-/g, '');
      const rearrangedDigits =
        digits.slice(4, 6) + digits.slice(6) + digits.slice(0, 4);
      if (result?.status === 200) {
        dispatch(patientAutoCompleteSlice(response));
        setFieldValue('first_name', response?.first_name);
        setFieldValue('last_name', response?.last_name);
        setFieldValue('preferred_name', response?.preferred_name);
        setFieldValue('phone_text', response?.phone_text.replace(/^(\+1)/, ''));
        setFieldValue('email_text', response?.email_text);
        setFieldValue('birth_date', rearrangedDigits);
        setShowExistingFlag(true);
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const patientNamesOrgAction = () => {
  return async (dispatch) => {
    try {
      const { url } = patientNamesOrgConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(patientNamesOrgSlice(response));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const flagNameOrgAction = () => {
  return async (dispatch) => {
    try {
      const { url } = flagNameOrgConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.setting;
      if (result?.status === 200) {
        dispatch(flagNameOrgSlice(response));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const practitionerNamesbyOrgId = () => {
  return async (dispatch) => {
    try {
      const { url } = practitionerNamesOrgConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.practitioner;
      if (result?.status === 200) {
        dispatch(practitionerNamesOrgbyIdSlice(response));
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const settingsOrgFlag = () => {
  return async (dispatch) => {
    dispatch(selfAPILoadingSlice(true));
    try {
      const { url } = settingsOrgFlagConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(settingsOrgFlagSlice(response));
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(selfAPILoadingSlice(false));
    }
  };
};

export const getPractitionerPreferences = (body, setFieldValue) => {
  return async (dispatch) => {
    try {
      const { url } = practitionerPreferencesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, body, { headers });
      let response = result?.data?.response?.preferences;
      if (result?.status === 200) {
        if (response?.length == 0) {
          response = [{ notification: '', number_of: '', duration: '' }];
        }
        dispatch(
          getPractitionerPreferencesSlice(
            response.error
              ? {
                  notification_preference: [
                    { notification: '', number_of: '', duration: '' },
                  ],
                  emails: [],
                }
              : response
          )
        );
        setFieldValue(
          'notifications',
          response?.notification_preference &&
            response?.notification_preference.length
            ? response?.notification_preference
            : []
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const getAppointmentDetailsByUuidAction = (
  appt_uuid,
  setEditAppointmentOpen
) => {
  return async (dispatch) => {
    dispatch(appointmentLoading(true));
    try {
      const { url } = getAppointmentDetailsbyUuidConfig(appt_uuid);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(appointmentLoading(false));
        setEditAppointmentOpen(true);
        dispatch(getAppointmentDetailsByUuidSlice(response));
        dispatch(
          getConditionByAppointmentType(
            response?.appointment_details?.practitioner_id,
            response?.appointment_details?.appointment_type_id,
            false
          )
        );
        const body = {
          practitioner_id: response?.appointment_details?.practitioner_id,
          condition_id: response?.appointment_details?.condition_id,
        };
        dispatch(getPractitionerPreferences(body));
      }
    } catch (e) {
      dispatch(appointmentLoading(false));
      showToastError('Unable to view the appointment');
    }
  };
};

export const editAppointmentAction = (
  appt_uuid,
  payload,
  setIsOpen,
  setConditionByType,
  setNotifications,
  setUpdatedEmailsArray,
  startIndex,
  setSendNow,
  isfilterOn,
  setSubmitLoading,
  filterValue
) => {
  return async (dispatch) => {
    try {
      const { url } = editAppointmentConfig(appt_uuid);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        setIsOpen(false);
        setSubmitLoading(false);
        showToastSuccess('Appointment edited successfully');
        setConditionByType([]);
        setNotifications([]);
        setUpdatedEmailsArray([]);
        setSendNow(false);
        dispatch(getSettingsNotificationsSlice(null));
        if (isfilterOn) {
          dispatch(
            getAppointmentByFilter(
              filterValue?.doctorName,
              filterValue?.patientName,
              getAppointmentAllStartDateFilter(filterValue?.startDate),
              getAppointmentAllEndDateFilter(filterValue?.endDate),
              filterValue?.status,
              'reload',
              startIndex,
              filterValue?.patientId || '',
              'start_date',
              'desc'
            )
          );

          dispatch(appointmentLoading(true));
        } else {
          dispatch(
            getAppointmentsByStatus(startIndex, undefined, 'start_date', 'desc')
          );
        }
        dispatch(getAppointmentPractitionerAndPatients());
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export const convertAppointmentToAuraEncounterAction = (
  appt_uuid,
  hideConvertAppointmentToAuraModal,
  startIndex,
  isfilterOn,
  setSubmitLoading,
  filterValue
) => {
  return async (dispatch) => {
    try {
      const { url } = convertAppointmentToAuraEncounterConfig(appt_uuid);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.put(url, null, { headers });
      if (result?.status === 200) {
        hideConvertAppointmentToAuraModal();
        setSubmitLoading(false);
        showToastSuccess('Appointment edited successfully');
        if (isfilterOn) {
          dispatch(
            getAppointmentByFilter(
              filterValue?.doctorName,
              filterValue?.patientName,
              getAppointmentAllStartDateFilter(filterValue?.startDate),
              getAppointmentAllEndDateFilter(filterValue?.endDate),
              filterValue?.status,
              'reload',
              startIndex,
              filterValue?.patientId || '',
              'start_date',
              'desc'
            )
          );

          dispatch(appointmentLoading(true));
        } else {
          dispatch(
            getAppointmentsByStatus(startIndex, undefined, 'start_date', 'desc')
          );
        }
        dispatch(getAppointmentPractitionerAndPatients());
      } else {
        setSubmitLoading(false);
        hideConvertAppointmentToAuraModal();
        showToastError('Some error occured. Please try again');
      }
    } catch (e) {
      setSubmitLoading(false);
      hideConvertAppointmentToAuraModal();
      showToastError('Some error occured. Please try again');
    }
  };
};

export const getAppointmentPractitionerAndPatients = () => {
  return async (dispatch) => {
    try {
      const { url: urlPatient } = getPatientDetailsByOrgConfig();
      const { url: urlPractitioner } = getPractionerDetailsByOrgConfig();
      const token = FronteggContext.getAccessToken();

      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const [resultPatient, resultPractitioner] = await Promise.all([
        Axios.get(urlPatient, { headers }),
        Axios.get(urlPractitioner, { headers }),
      ]);

      const patients = resultPatient?.data?.patients ?? [];
      const practitioners = resultPractitioner?.data?.practitioners ?? [];

      const response = {
        practitioner: practitioners,
        patient: patients,
      };

      dispatch(getPractitionersAndPatientsSlice(response));
    } catch (e) {
      console.log(e);
    }
  };
};

export const checkPatientDetailsAction = (
  payload,
  setPatientModalOpen,
  setCheckExistingButtonFlag,
  setCheckPatientId
) => {
  return async (dispatch) => {
    const { url } = checkPatientDetailsConfig();
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };
    const result = await Axios.post(url, payload, { headers });
    const response = result?.data;
    if (result?.status === 200) {
      dispatch(existingPatientDetailsSlice(response));
      setPatientModalOpen(true);
      setCheckExistingButtonFlag(true);
      setCheckPatientId(null);
    }
  };
};

// Notification History
export const notificationHistory = (payload, setIsnotificationHistoryOpen) => {
  return async (dispatch) => {
    dispatch(appointmentLoading(true));
    try {
      let { url } = notificationHistoryConfig();

      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(appointmentLoading(false));
        setIsnotificationHistoryOpen(true);
        dispatch(getNotificationHistorySlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
      dispatch(appointmentLoading(false));
      setIsnotificationHistoryOpen(false);
    }
  };
};

export const getSyncAppointmentHistory = (page, per_page) => {
  return async (dispatch) => {
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };
    dispatch(bulkAppointmentHistoryLoadingSlice(true));
    dispatch(bulkAppointmentHistorySlice([]));
    try {
      const params = {
        page: page,
        per_page: per_page,
      };
      const result = await Axios.get('/appointments/sync/history', {
        headers,
        params,
      });
      if (result?.status === 200) {
        dispatch(bulkAppointmentHistorySlice(result.data));
      } else {
        showToastError('Failed to get appointment upload history');
      }
    } catch (error) {
      console.error(error);
      showToastError(
        `Error getting appointment upload history: ${error.message}`
      );
    } finally {
      dispatch(bulkAppointmentHistoryLoadingSlice(false));
    }
  };
};

export const reProcessUpload = (s3_key, bucket_name) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };

      const payload = {
        s3_key: s3_key,
        bucket_name: bucket_name,
      };

      const result = await Axios.post('/appointments/sync/s3', payload, {
        headers,
      });

      if (result?.status === 200) {
        showToastSuccess('Upload re-processed successfully');
        return true;
      }
    } catch (error) {
      console.error(error);
      showToastError('Failed to re-process upload');
      return false;
    }
  };
};

export const getRecentSearchAction = (screen) => {
  return async (dispatch) => {
    try {
      const { url } = getRecentSearchConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const body = {
        screen: screen,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data;
      if (result.status === 200 && response) {
        dispatch(getRecentSearchSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};
export const addRecentSearchAction = (payload, screen) => {
  return async (dispatch) => {
    try {
      const { url } = addRecentSearchConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const data = {
        payload: payload,
        screen: screen,
      };
      const result = await Axios.post(url, data, { headers });
      const response = result?.data;
      if (result.status === 200 && response) {
        dispatch(getRecentSearchAction(screen));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const downloadCSVAction = (payload) => {
  return async (dispatch) => {
    try {
      const { url } = downloadCSVConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result.status === 200 && response) {
        dispatch(csvDownloadUrlSlice(response?.download_url));
      }
    } catch (e) {
      console.error('error from download csv action', e);
      showToastError('Error occurred while downloading file');
      dispatch(csvDownloadUrlSlice(null));
    }
  };
};

export const uploadCSVAction = (payload) => {
  return async () => {
    try {
      const { url } = uploadCSVConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result.status === 200 && response) {
        showToastSuccess('File uploaded successfully');
      }
    } catch (e) {
      console.error('error from upload csv action', e);
      showToastError('Error occurred while uploading file');
    }
  };
};

export const getPatientNames = (patient_name) => {
  return async (dispatch) => {
    try {
      const { url } = getPatientNamesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.post(url, { patient_name }, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getPatientNamesListSlice(response?.patient_details));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getCSVColumnMappings = (
  org_uuid,
  key = 'appt_bulk_upload_settings'
) => {
  return async (dispatch) => {
    try {
      dispatch(csvColumnMappingsLoadingSlice(true));
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const column_mapping = response?.settings?.column_mapping;
      if (result?.status === 200 && column_mapping) {
        dispatch(getCSVColumnMappingsSlice(column_mapping));
        dispatch(
          getCSVDateTimeFormatsSlice({
            date_format: response?.settings?.date_format ?? '%m/%d/%Y',
            time_format: response?.settings?.time_format ?? '%H:%M',
            birth_date_format:
              response?.settings?.birth_date_format ?? '%m/%d/%Y',
          })
        );
      } else {
        dispatch(getCSVColumnMappingsSlice({}));
        dispatch(getCSVDateTimeFormatsSlice({}));
      }
    } catch (e) {
      dispatch(getCSVColumnMappingsSlice({}));
      dispatch(getCSVDateTimeFormatsSlice({}));
    } finally {
      dispatch(csvColumnMappingsLoadingSlice(false));
    }
  };
};

export const getCSVTimezone = (org_uuid, key = 'appt_bulk_upload_settings') => {
  return async (dispatch) => {
    try {
      dispatch(getCSVTimezoneLoadingSlice(true));
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const timezone = response?.settings?.timezone;
      if (result?.status === 200 && timezone) {
        dispatch(getCSVTimezoneSlice(timezone));
      } else {
        dispatch(getCSVTimezoneSlice(null));
      }
    } catch (e) {
      dispatch(getCSVTimezoneSlice(null));
    } finally {
      dispatch(getCSVTimezoneLoadingSlice(false));
    }
  };
};

export const getProviderMappings = (
  org_uuid,
  key = 'appt_bulk_upload_settings'
) => {
  return async (dispatch) => {
    try {
      dispatch(providerMappingsLoadingSlice(true));
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const provider_mapping = response?.settings?.practitioner_mapping;
      if (result?.status === 200 && provider_mapping) {
        // save reverse mapping for easy lookup
        const reverse_mapping = {};
        for (const [key, value] of Object.entries(provider_mapping)) {
          if (!Object.prototype.hasOwnProperty.call(reverse_mapping, value)) {
            reverse_mapping[value] = [key];
          } else {
            reverse_mapping[value].push(key);
          }
        }
        dispatch(getProviderMappingsSlice(reverse_mapping));
      }
    } catch (e) {
      // console.error("Could not fetch provider mappings:", e);
      dispatch(getProviderMappingsSlice({}));
    } finally {
      dispatch(providerMappingsLoadingSlice(false));
    }
  };
};

export const updateMappings = (
  payload,
  org_uuid,
  mapping_type,
  key = 'appt_bulk_upload_settings'
) => {
  return async () => {
    try {
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      if (key === 'encounter_bulk_upload_settings') {
        delete headers['Impersonate-Org-UUID'];
        delete headers['Headless-Mode'];
      }
      const result = await Axios.put(url, payload, { headers });
      const response = result?.data;
      if ((result?.status === 200 || result?.status === 201) && response) {
        showToastSuccess(
          `${mapping_type.charAt(0).toUpperCase() + mapping_type.slice(1)} updated successfully`
        );
      }
    } catch (e) {
      showToastError(`Error updating ${mapping_type}`);
    }
  };
};

export const getAppointmentStatusMappings = (
  org_uuid,
  key = 'appt_bulk_upload_settings'
) => {
  return async (dispatch) => {
    try {
      dispatch(getAppointmentStatusMappingsLoadingSlice(true));
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const appointment_status_mapping =
        response?.settings?.appointment_status_mapping;
      if (result?.status === 200 && appointment_status_mapping) {
        dispatch(getAppointmentStatusMappingsSlice(appointment_status_mapping));
      } else {
        dispatch(getAppointmentStatusMappingsSlice({}));
      }
    } catch (e) {
      dispatch(getAppointmentStatusMappingsSlice({}));
    } finally {
      dispatch(getAppointmentStatusMappingsLoadingSlice(false));
    }
  };
};

export const getConditionMappings = (
  org_uuid,
  key = 'appt_bulk_upload_settings'
) => {
  return async (dispatch) => {
    try {
      dispatch(getConditionMappingsLoadingSlice(true));
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const condition_mapping = response?.settings?.condition_mapping;
      if (result?.status === 200 && condition_mapping) {
        // save reverse mapping for easy lookup
        const reverse_mapping = {};
        for (const [key, value] of Object.entries(condition_mapping)) {
          if (!Object.prototype.hasOwnProperty.call(reverse_mapping, value)) {
            reverse_mapping[value] = [key];
          } else {
            reverse_mapping[value].push(key);
          }
        }
        dispatch(getConditionMappingsSlice(reverse_mapping));
      } else {
        dispatch(getConditionMappingsSlice({}));
      }
    } catch (e) {
      dispatch(getConditionMappingsSlice({}));
    } finally {
      dispatch(getConditionMappingsLoadingSlice(false));
    }
  };
};

export const getLookbackPeriods = (
  org_uuid,
  key = 'appt_bulk_upload_settings'
) => {
  return async (dispatch) => {
    try {
      dispatch(getLookbackPeriodsLoadingSlice(true));
      const { url } = getOrganizationSettingsMappingConfig(key);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      const lookback_periods = response?.settings?.lookback_period;
      if (result?.status === 200 && lookback_periods) {
        dispatch(getLookbackPeriodsSlice(lookback_periods));
      } else {
        dispatch(getLookbackPeriodsSlice({}));
      }
    } catch (e) {
      dispatch(getLookbackPeriodsSlice({}));
    } finally {
      dispatch(getLookbackPeriodsLoadingSlice(false));
    }
  };
};

export const markAsProcessedAction = (appointment_id) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const payload = {
        appointment_id,
      };
      const result = await Axios.patch(
        '/v2/mark_appointment_as_processed',
        payload,
        { headers }
      );
      const response = result?.data;
      if (result?.status === 200 && response) {
        showToastSuccess('Appointment marked as processed');
        return true;
      }
      return false;
    } catch (e) {
      showToastError('Error marking appointment as processed');
      return false;
    }
  };
};

export const unmarkAsProcessedAction = (appointment_id) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const payload = {
        appointment_id,
      };
      const result = await Axios.patch(
        '/v2/unmark_appointment_as_processed',
        payload,
        { headers }
      );
      const response = result?.data;
      if (result?.status === 200 && response) {
        showToastSuccess('Appointment status reverted');
        return true;
      }
      return false;
    } catch (e) {
      showToastError('Error reverting appointment status');
      return false;
    }
  };
};
